import { useState } from "react";
import {
  demoEngagementModalBody,
  demoEngagementModalHeader,
  demoEngagementModalSubHeader
} from "../../util/constants";
import { Button } from "../CommonUIComponents/Button/Button";
import { Modal } from "../CommonUIComponents/Modal/Modal";
import "./DemoEngagementConfirmModal.scss";
import { LoadingIndicatorEmbed } from "../CommonUIComponents/LoadingIndicator/LoadingIndicatorEmbed";

function ModalBody({ errorMessage, demoEngLoader }) {
  return (
    <div className="demo-engagement-main-modal-body">
      <LoadingIndicatorEmbed show={demoEngLoader}>
        <p>{demoEngagementModalSubHeader}</p>
        <p className="demo-endagement-delete-modal-body">{demoEngagementModalBody}</p>
        {errorMessage && <p className="demo-endagement-error-message">{errorMessage}</p>}
      </LoadingIndicatorEmbed>
    </div>
  );
}

function ModalFooter({ handleCancelClick, onConfirm }) {
  const [ isConfirmDisabled, setIsConfirmDisabled] = useState(false);
  return (
    <div className="demo-endagement-delete-modal-footer">
      <Button onClick={handleCancelClick} variant="secondary">
        {"Cancel"}
      </Button>
      <Button onClick={()=>{
        onConfirm();
        setIsConfirmDisabled(true);
      }} disabled={isConfirmDisabled} variant="primary">
        {"Confirm"}
      </Button>
    </div>
  );
}

export function DemoEngagementConfirmModal({
  isModalVisible,
  onClose,
  onConfirm,
  errorMessage='',
  demoEngLoader=false
}) {
  return (
    <Modal
      show={isModalVisible}
      onClose={onClose}
      header={
        <div className="file-version-history-modal-header">
          <span>{demoEngagementModalHeader}</span>
        </div>
      }
      body={<ModalBody errorMessage={errorMessage} demoEngLoader={demoEngLoader} />}
      footer={<ModalFooter handleCancelClick={onClose} onConfirm={onConfirm} />}
    />
  );
}
